import React from 'react'
import { Component } from 'reflux'
import { PurchaseOrderStore, PurchaseOrderStoreActions } from 'Stores/purchaseOrderStore'
import { Button, Grid, Paper } from '@material-ui/core'
import { Redirect } from 'react-router-dom'

export default class PurchaseOrderSend extends Component {
  constructor(props) {
    super(props)
    this.stores = [PurchaseOrderStore]
    this.storeKeys = [
      'status',
      'purchaseOrderDetails',
      'suppliers',
      'msbAdminUsers',
      'products',
      'currencies',
      'pdfBlob',
      'pdfBytes',
      'showPdfPreview',
      'showPdfFailed',
      'pdfReady'
    ]
    this.state = {
      pdfUrl: null,
      showPdfPreview: false
    }
  }

  componentDidMount() {
    this.generatePDF()
  }

  groupOrderLines = lines => {
    const grouped = {}
    lines.forEach((line, idx) => {
      const key = `${line.productVariationID}||${line.description}`
      if (!grouped[key]) {
        grouped[key] = { ...line, amountOfProducts: Number(line.amountOfProducts), _indices: [idx] }
      } else {
        grouped[key].amountOfProducts += Number(line.amountOfProducts)
        grouped[key]._indices.push(idx)
      }
    })
    return Object.values(grouped)
  }

  formatDate(dateString) {
    if (!dateString) return ''
    const d = new Date(dateString)
    if (isNaN(d)) return ''
    return d.toISOString().slice(0, 10)
  }

  arrayBufferToBase64(buffer) {
    let binary = ''
    const bytes = new Uint8Array(buffer)
    const len = bytes.byteLength
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i])
    }
    return btoa(binary)
  }

  getEmailBody(po) {
    if (
      po &&
      po.supplier &&
      typeof po.supplier.corporateIdentificationNumber === 'string' &&
      !/^[A-Za-z]/.test(po.supplier.corporateIdentificationNumber)
    ) {
      return `Kære ${po.supplier?.supplierName}<br/><br/>
          BÆMÆRK: Vi (MS Branding A/S) har skiftet navn til Upgrader A/S<br/><br/>
          Vedhæftet findes rekvisition #${po.purchaseOrderNumber}.<br/><br/>
          Faktura skal sendes til <a href="mailto:faktura@upgrader.dk">faktura@upgrader.dk</a><br/>
          Ordrebekræftelse sendes til <a href="mailto:shoppen@upgrader.dk">shoppen@upgrader.dk</a><br/><br/>
          Bekræft venligst modtagelse af denne ordre på skrift.<br/>
          Med venlig hilsen,<br/>
          Upgrader A/S`
    } else {
      return `Dear ${po.supplier?.supplierName}<br/><br/>
          Attached you will find requisition #${po.purchaseOrderNumber}.<br/><br/>
          Invoices should be sent to <a href="mailto:faktura@upgrader.dk">faktura@upgrader.dk</a><br/>
          Order confirmation should be sent to <a href="mailto:shoppen@upgrader.dk">shoppen@upgrader.dk</a><br/><br/>
          Please confirm receipt of this order in writing.<br/>
          Best regards,<br/>
          Upgrader A/S`
    }
  }

  handleSendEmail = async () => {
    const po = this.state.purchaseOrderDetails
    const pdfBytes = this.state.pdfBytes
    let pdfBase64
    if (typeof pdfBytes === 'string') {
      pdfBase64 = pdfBytes
    } else if (pdfBytes instanceof Uint8Array || Array.isArray(pdfBytes)) {
      pdfBase64 = this.arrayBufferToBase64(pdfBytes)
    } else {
      pdfBase64 = ''
    }
    const toEmail = po.alternativeMail || po.supplier?.email

    const emailProperties = {
      fromMail: 'shoppen@upgrader.dk',
      toMail: toEmail,
      body: this.getEmailBody(po),
      pdfBytes: pdfBase64,
      purchaseOrderNumber: po.purchaseOrderNumber
    }
    try {
      await PurchaseOrderStoreActions.sendGraphMail(emailProperties)
      return <Redirect to={'/purchase-orders'} />
    } catch (err) {
      alert('Kunne ikke sende e-mail: ' + err.message)
    }
  }

  handleApproved = () => {
    const po = this.state.purchaseOrderDetails
    try {
      PurchaseOrderStoreActions.approvedOrdered(po.purchaseOrderNumber)
      return <Redirect to={'/purchase-orders'} />
    } catch (err) {
      alert('Kunne ikke sende e-mail: ' + err.message)
    }
  }

  generatePDF() {
    const poDetails = this.state.purchaseOrderDetails || {}
    const supplier = poDetails.supplier || {}
    const isDanish = typeof supplier.corporateIdentificationNumber === 'string' && !/^[A-Za-z]/.test(supplier.corporateIdentificationNumber)
    const orderLines = this.groupOrderLines(poDetails.purchaseOrderlines) || []
    const taxPercent = isDanish ? 0.25 : 0.0
    const taxBase = orderLines.reduce((sum, line) => sum + line.pricePerItem * line.amountOfProducts, 0)
    const taxAmount = isDanish ? (taxBase * taxPercent).toFixed(2) : 0
    const totalAmount = (taxBase + parseFloat(taxAmount)).toFixed(2)
    const pdfData = {
      isDanish: isDanish,
      purchaseOrderNumber: poDetails.purchaseOrderNumber,
      dateCreated: this.formatDate(poDetails.dateCreated),
      supplierName: supplier.supplierName || '',
      supplierUID: supplier.supplierUID || '',
      email: poDetails.alternativeMail ? poDetails.alternativeMail : supplier.email,
      supplierAddress: supplier.address || '',
      currency: poDetails.currency || 'DKK',
      orderType: poDetails.orderType || 'Almindelig',
      deliveryAddress: poDetails.isDropShip
        ? isDanish
          ? 'Se nedenfor'
          : 'See below'
        : [poDetails.deliveryAddress1, poDetails.deliveryAddress2, poDetails.deliveryAddress3, poDetails.deliveryAddress4, poDetails.deliveryAddress5]
            .filter(Boolean)
            .join(', '),
      ourRef: poDetails.ourRef || '',
      theirRef: poDetails.theirRef || ' ',
      alternativeDeliveryTime: this.formatDate(poDetails.alternativeDeliveryTime),
      alternativeMail: poDetails.alternativeMail || '',
      purchaseOrderNote: poDetails.purchaseOrderNote || '',
      purchaseOrderlines: orderLines.map(line => ({
        ...line,
        pricePerItem: Number(line.pricePerItem),
        amountOfProducts: Number(line.amountOfProducts),
        totalLinePrice: (line.pricePerItem * line.amountOfProducts).toFixed(2)
      })),
      taxAmount: taxAmount,
      taxBase: taxBase,
      totalAmount: totalAmount,
      taxPercentage: (taxPercent * 100).toString() + '%'
    }
    PurchaseOrderStoreActions.generatePurchaseOrderPdf(pdfData)
  }

  render() {
    const info = {
      supplier: this.state.purchaseOrderDetails?.supplier?.supplierName,
      email: this.state.purchaseOrderDetails?.supplier?.email,
      orderNumber: this.state.purchaseOrderDetails?.purchaseOrderNumber,
      total: (this.state.purchaseOrderDetails?.purchaseOrderlines || []).reduce((sum, l) => sum + l.pricePerItem * l.amountOfProducts, 0)
    }

    const pdfReady = Boolean(this.state.pdfReady)

    if (this.state.showPdfPreview) {
      return (
        <Grid container spacing={4} style={{ padding: 32 }}>
          <Grid item xs={12} md={7}>
            <Paper style={{ height: '80vh', overflow: 'hidden' }}>
              <iframe src={this.state.pdfBlob} title='PDF Preview' width='100%' height='100%' style={{ border: 'none', minHeight: 600 }} />
            </Paper>
          </Grid>
          <Grid item xs={12} md={5}>
            <Paper style={{ padding: 32, display: 'flex', flexDirection: 'column', alignItems: 'flex-start', height: '80vh' }}>
              <h2>Indkøbsordre info</h2>
              <div>
                <strong>Leverandør:</strong> {info.supplier}
              </div>
              <div>
                <strong>Ordrenummer:</strong> {info.orderNumber}
              </div>
              <div>
                <strong>Email:</strong> {info.email}
              </div>
              <div>
                <strong>Total:</strong> {info.total?.toLocaleString('da-DK', { minimumFractionDigits: 2 })} DKK
              </div>
              <div style={{ margin: '24px 0 8px 0', width: '100%' }}>
                <strong>E-mail tekst:</strong>
                <Paper variant='outlined' style={{ padding: 12, marginTop: 8, background: '#fafafa' }}>
                  <span dangerouslySetInnerHTML={{ __html: this.getEmailBody(this.state.purchaseOrderDetails) }} />
                </Paper>
              </div>
              <div style={{ flex: 1 }} />
              <Button disabled={!pdfReady} variant='contained' color='primary' style={{ marginBottom: 16 }} onClick={this.handleApproved}>
                Bestilt via Website og Godkend
              </Button>
              <Button disabled={!pdfReady} variant='contained' color='primary' style={{ marginBottom: 16 }} onClick={this.handleSendEmail}>
                Godkend & Send Mail
              </Button>
              <Button variant='outlined' color='secondary' onClick={this.handleClosePreview}>
                Luk
              </Button>
            </Paper>
          </Grid>
        </Grid>
      )
    } else {
      return (
        <React.Fragment>
          <Grid>
            <Paper>
              <p>Loading</p>
              <p>{this.state.pdfUrl}</p>
            </Paper>
          </Grid>
        </React.Fragment>
      )
    }
  }
}
